// TODO: check style
import React, { memo } from 'react'
import IconSvg from '@/components/IconSvg'
import classNames from 'classnames'
import dayjs from 'dayjs'
import { useTranslation } from '@/libs/next-lang'
import styles from './index.module.less'

interface Props {
  grade?: 0 | 1 | 2 // 会员等级, 免费、高级、高级试用
  validityPeriod?: number // 会员有效期
  classNames?: string
  subTitle?: React.ReactElement | string | null
  layout?: 'default' | 'long' // 默认和长款
  onClick?: () => void
}

const MemberArea = memo((props: Props) => {
  const { subTitle = null, grade, validityPeriod, layout = 'default', onClick = () => {} } = props
  const { t } = useTranslation(['components'])

  const txt1: string = t('components:t76')
  return (
    <div
      className={classNames(styles['member-area-wrapper'], {
        [props.classNames]: props.classNames,
      })}
    >
      <div className="member-area-content" onClick={onClick}>
        <IconSvg type="icon-huangguanshen" />
        {!grade ? (
          <div style={{ flex: 1, display: 'flex', flexWrap: 'wrap', padding: '0 10px' }}>
            <span
              style={{ color: '#252523', fontSize: 13 }}
              className="single-line-ellipsis-2"
              title={txt1}
            >
              {txt1}
            </span>
            {subTitle && (
              <span style={{ color: 'rgb(99, 72, 16)', marginRight: 20, marginLeft: 10 }}>
                {subTitle}
              </span>
            )}
          </div>
        ) : (
          <div className={classNames('ml-10 mr-10', layout)} style={{ flex: 1, fontSize: 12 }}>
            <div style={{ color: '#252523', whiteSpace: 'nowrap' }}>
              <span style={{ fontSize: 12, fontWeight: 'bold' }}> {t('components:t77')}</span>
              <span
                className="ml-5"
                style={{
                  backgroundColor: '#2C3340',
                  padding: '3px 5px',
                  color: '#fff',
                  transform: 'scale(.75)',
                  borderRadius: 8,
                  borderBottomLeftRadius: 0,
                  display: 'inline-block',
                  lineHeight: '12px',
                }}
              >
                {grade === 2 ? t('components:t78') : t('components:t79')}
              </span>
            </div>
            {layout === 'default' ? (
              <div
                style={{
                  display: 'flex',
                  flexWrap: 'wrap',
                  color: '#634810',
                  lineHeight: '12px',
                  fontSize: '10px',
                }}
              >
                <span style={{ flex: 'none' }}>
                  {grade === 2 ? t('components:t80') : t('components:t81')}:
                </span>
                <span style={{ marginLeft: 3 }}>{dayjs(validityPeriod).format('YYYY-MM-DD')}</span>
              </div>
            ) : (
              <div
                style={{
                  display: 'flex',
                  flexWrap: 'wrap',
                  color: '#634810',
                  marginLeft: 10,
                  marginRight: 30,
                }}
              >
                <span style={{ flex: 'none' }}>
                  ·&nbsp;{grade === 2 ? t('components:t80') : t('components:t81')}:
                </span>
                <span style={{ marginLeft: 3 }}>{dayjs(validityPeriod).format('YYYY-MM-DD')}</span>
              </div>
            )}
          </div>
        )}
        <i
          style={{
            background: '#532E14',
            display: 'flex',
            width: 18,
            height: 18,
            borderRadius: 9,
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          <IconSvg type="icona-you1" style={{ color: '#fff', fontSize: 8 }} />
        </i>
      </div>
    </div>
  )
})

export default MemberArea
